var React = require('react');

function Search (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"AA42B1B5-AC37-4C5A-8242-37C9184EE762"),React.createElement("g",{"id":"propuesta-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"home","transform":"translate(-1359.000000, -19.000000)","stroke":"#333433","strokeWidth":"2"},React.createElement("g",{"id":"SEARCH","transform":"translate(1359.790928, 19.000000)"},[React.createElement("circle",{"id":"Oval","cx":"10.5","cy":"10.5","r":"9.5","key":0}),React.createElement("line",{"x1":"17.5","y1":"17.5","x2":"23.5","y2":"23.5","id":"Line","strokeLinecap":"square","key":1})])))]);
}

Search.defaultProps = {"width":"26px","height":"25px","viewBox":"0 0 26 25","version":"1.1"};

module.exports = Search;

Search.default = Search;
